/* eslint-disable @typescript-eslint/no-explicit-any */
import { Link, useNavigate } from "react-router-dom";
import { Button2 } from "../../../Components/Buttons";
import { toast } from "react-toastify";
import "./BrandSignUp.css";
import { useEffect, useState } from "react";
import { useAuth } from "../../../Providers/Auth";
import mixpanel from "mixpanel-browser";
import { ArrowRight, Loader2, Mail } from "lucide-react";
import { Input } from "@/shadcnComponents/ui/input";
import { Label } from "@/shadcnComponents/ui/label";
import {
  BadgeCheck,
  Headphones,
  LineChart,
  LogOut,
  Sparkles,
} from "lucide-react";
import { Button } from "@/shadcnComponents/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/shadcnComponents/ui/dialog";

export const BrandHeader = (props) => {
  const navigate = useNavigate();

  return (
    <>
      <header
        style={{ ...props?.style, width: "100%" }}
        className="BrandHeader"
      >
        <div className="BrandHeaderLogo">
          <img
            onClick={() => {
              navigate("/Brand");
            }}
            src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/brand-logo-BwAxsepq%5B1%5D%20(1)-JunPyjnSrXhN6ca8y4RQ7u64I33zMv.png"
            alt=""
            className="my-auto w-20 md:w-32 cursor-pointer"
          />
        </div>
        {props.visible && (
          <Button2
            text={props.text}
            onClick={props.onClick}
            icon={props.icon}
            textColor={props.textColor}
            borderColor={props.ButtonBorderColor}
            rightIcon={undefined}
            background={undefined}
          />
        )}
      </header>
    </>
  );
};

export const BrandSignUp = () => {
  return (
    <>
      <div className="min-h-screen">
        <BrandSignUpHeader />
        <div className="grid min-h-[calc(100vh-4rem)] grid-cols-1 lg:grid-cols-2">
          <div className="hidden lg:block">
            <div className="flex h-full flex-col justify-between bg-muted p-10">
              <div className="space-y-6">
                <div className="space-y-4">
                  <div className="space-y-2">
                    <h3 className="font-semibold">
                      Real Results. Real Impact.
                    </h3>
                    <div className="space-y-4">
                      <blockquote className="border-l-2 pl-6">
                        It was a good experience with anchors; the result-based
                        payment model excited me initially, so we tried the
                        service. It was a good experience with anchors; the
                        result-based payment model excited me initially, so we
                        tried the service and the proven result kept us going.
                        <footer className="mt-2 text-sm text-muted-foreground">
                          - Ashish Gupta, Founder, Fretbox
                        </footer>
                      </blockquote>
                    </div>
                  </div>
                </div>
              </div>
              <div className="space-y-4">
                <div className="grid grid-cols-2 gap-6">
                  <div className="flex items-start gap-4">
                    <div className="rounded-lg bg-background p-2">
                      <BadgeCheck className="h-6 w-6 text-primary" />
                    </div>
                    <div>
                      <h4 className="font-semibold">Source-of-Truth Data</h4>
                      <p className="text-sm text-muted-foreground">
                        No guesswork ; real influencer insights
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="rounded-lg bg-background p-2">
                      <LineChart className="h-6 w-6 text-primary" />
                    </div>
                    <div>
                      <h4 className="font-semibold">Real-time Analytics</h4>
                      <p className="text-sm text-muted-foreground">
                        Track performance live
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="rounded-lg bg-background p-2">
                      <Sparkles className="h-6 w-6 text-primary" />
                    </div>
                    <div>
                      <h4 className="font-semibold">Smart Matching</h4>
                      <p className="text-sm text-muted-foreground">
                        AI-powered recommendations
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="rounded-lg bg-background p-2">
                      <Headphones className="h-6 w-6 text-primary" />
                    </div>
                    <div>
                      <h4 className="font-semibold">Dedicated Support</h4>
                      <p className="text-sm text-muted-foreground">
                        24/7 expert assistance
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex items-center justify-center bg-dot-pattern p-6">
            <BrandSignupForm />
          </div>
        </div>
      </div>
    </>
  );
};

export const BrandSignUpHeader = ({ logout }: { logout?: boolean }) => {
  const handleLogout = () => {
    localStorage.removeItem("jwtToken");
    localStorage.removeItem("UserType");
    // mixpanel.reset();
    window.open("/brand", "_self");
  };

  return (
    <header className="border-b">
      <div className="container flex h-16 items-center justify-between px-4">
        <Link to="/brand" className="flex items-center space-x-2">
          <img
            src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/brand-logo-BwAxsepq%5B1%5D%20(1)-JunPyjnSrXhN6ca8y4RQ7u64I33zMv.png"
            alt="Anchors Logo"
            width={120}
            height={32}
            className="h-8 w-auto"
          />
        </Link>
        {logout && (
          <Dialog>
            <DialogTrigger asChild>
              <Button
                variant="ghost"
                size="sm"
                className="text-muted-foreground"
              >
                <LogOut className="mr-2 h-4 w-4" />
                Logout
              </Button>
            </DialogTrigger>
            <DialogContent>
              <DialogHeader>
                <DialogTitle>Logout Confirmation</DialogTitle>
                <DialogDescription>
                  Are you sure you want to logout? You'll need to login again to
                  access your account.
                </DialogDescription>
              </DialogHeader>
              <DialogFooter>
                <Button
                  variant="outline"
                  onClick={() => document.querySelector("dialog")?.close()}
                >
                  Cancel
                </Button>
                <Button onClick={handleLogout} variant="destructive">
                  Logout
                </Button>
              </DialogFooter>
            </DialogContent>
          </Dialog>
        )}
      </div>
    </header>
  );
};

export function BrandSignupForm() {
  const [isLoading, setIsLoading] = useState(false);
  const [showOTP, setShowOTP] = useState(false);
  const [email, setEmail] = useState("");
  const [countdown, setCountdown] = useState(0);
  const [Otp, SetOtp] = useState(null);

  const navigate = useNavigate();
  const authState = useAuth();

  if (
    localStorage.getItem("jwtToken") &&
    localStorage.getItem("UserType") === "Brand"
  ) {
    navigate("/Brand/Welcome");
  }
  useEffect(() => {
    mixpanel.track("Page visited Anchors Collab Brand SignUp");
  }, []);

  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [countdown]);

  const handleSubmit = async () => {
    try {
      if (!email) {
        return toast.error("Please Enter Your Mail", {
          position: "top-center",
          autoClose: 2000,
        });
      }
      const emailDomain = email.split("@")[1].toLowerCase();
      const forbiddenDomains = [
        "gmail.com",
        "yahoo.com",
        "outlook.com",
        "hotmail.com",
        "aol.com",
        "icloud.com",
        "protonmail.com",
        "mail.com",
        "zoho.com",
        "yandex.com",
        "gmx.com",
        "live.com",
        "msn.com",
        "inbox.com",
        "mail.ru",
      ];
      if (forbiddenDomains.includes(emailDomain)) {
        return toast.error(
          "Please use your company email ID. Personal email IDs are not accepted.",
          {
            position: "top-center",
            autoClose: 2000,
          }
        );
      }
      setIsLoading(true);
      const mailExist = await authState.getBrandByEmail(email);
      if (!mailExist.success) {
        const result = await authState.sendingOTPFeature(email);
        if (result.success) {
          mixpanel.track("Requested Otp for SignUp");
          toast.info("Otp Sent Successfully to your MailBox", {
            position: "top-center",
            autoClose: 2000,
          });
          setShowOTP(true);
          setCountdown(20);
          setIsLoading(false);
          // navigate(`/Brand/Otp-verify?email=${email}&type=SignUp`);
        } else {
          setIsLoading(false);
          return toast.error(result.Error, {
            position: "top-center",
            autoClose: 2000,
          });
        }
      } else {
        setIsLoading(false);
        return toast.error("This Mail Already Exist! Please Login", {
          position: "top-center",
          autoClose: 2000,
        });
      }
    } catch (e) {
      setIsLoading(false);
      return toast.error("Something went Wrong!", {
        position: "top-center",
        autoClose: 2000,
      });
    }
  };

  const handleResend = async () => {
    setIsLoading(true);
    const result = await authState.sendingOTPFeature(email);
    if (result.success) {
      mixpanel.track("Requested Resend Otp");
      setIsLoading(false);
      setCountdown(20);
      toast.info("Otp Sent Successfully to your MailBox", {
        position: "top-center",
        autoClose: 2000,
      });
    } else {
      setIsLoading(false);
      return toast.error(result.Error, {
        position: "top-center",
        autoClose: 2000,
      });
    }
  };

  const handleVerifyOTP = async () => {
    try {
      if (!Otp) {
        return toast.error("Enter a proper code", {
          position: "top-center",
          autoClose: 2000,
        });
      }
      setIsLoading(true);
      const result = await authState.verifyOTP(Otp, email, "SignUp");
      if (result?.Error) {
        setIsLoading(false);
        return toast.error(result?.Error, {
          position: "top-center",
          autoClose: 2000,
        });
      } else {
        setIsLoading(false);
      }
    } catch (e) {
      setIsLoading(false);
      console.log(e);
    }
  };

  return (
    <div className="mx-auto w-full max-w-sm space-y-6">
      <div className="space-y-2 text-center">
        <h1 className="text-3xl font-bold tracking-tighter">
          Create an account
        </h1>
        <p className="text-muted-foreground">Enter your email to get started</p>
      </div>
      {!showOTP ? (
        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <div className="relative">
              <Mail className="absolute left-3 top-3 h-5 w-5 text-muted-foreground" />
              <Input
                id="email"
                type="email"
                placeholder="m@example.com"
                className="pl-10"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>
          <div className="flex items-center space-x-2">
            <span className="text-sm">
              By continue, you have agree our{" "}
              <b
                className="underline cursor-pointer "
                onClick={() => {
                  mixpanel.track("Terms and Conditions link - Clicked");
                  window.open("https://www.anchors.in/termsConditions");
                }}
              >
                terms and conditions.
              </b>
            </span>
          </div>
          <Button
            onClick={handleSubmit}
            className="w-full"
            disabled={isLoading}
          >
            {isLoading ? (
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            ) : (
              <>
                Continue with Email
                <ArrowRight className="ml-2 h-4 w-4" />
              </>
            )}
          </Button>
        </div>
      ) : (
        <div className="space-y-4">
          <div className="rounded-lg bg-muted p-4">
            <div className="flex items-center justify-between">
              <span className="text-sm">{email}</span>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => setShowOTP(false)}
                className="h-auto p-0 text-primary hover:text-primary/90"
              >
                Change
              </Button>
            </div>
          </div>
          <div className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="otp">Enter OTP</Label>
              <Input
                value={Otp}
                id="otp"
                type="number"
                required
                maxLength={4}
                className="text-center text-lg tracking-widest"
                onChange={(e) => SetOtp(e.target.value)}
              />
            </div>
            <Button
              onClick={handleVerifyOTP}
              className="w-full"
              disabled={isLoading}
            >
              {isLoading ? (
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              ) : (
                "Verify OTP"
              )}
            </Button>
            <div className="text-center">
              <Button
                type="button"
                variant="link"
                className="text-sm"
                onClick={handleResend}
                disabled={isLoading || countdown > 0}
              >
                {countdown > 0 ? `Resend OTP in ${countdown}s` : "Resend OTP"}
              </Button>
            </div>
          </div>
        </div>
      )}
      <p className="text-center text-sm text-muted-foreground">
        Already have an account?{" "}
        <Link to="/brand/login" className="text-primary hover:underline">
          Login
        </Link>
      </p>
    </div>
  );
}
